import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Joint3D gizmo lines in the colour of their part, each at opacity 1 as Godot's gizmo materials
 * have. The caller mounts them inside a `PluginGizmo`, which makes them faint while unselected.
 */
import { GizmoLine } from '../../../../r3f/components/GizmoLine';
import { godotColorToLinear } from '../../../../r3f/godotColor';
/** `editors/3d_gizmos/gizmo_colors/joint`, `joint_body_a` and `joint_body_b` (`editor_settings.cpp:880-890`). */
const PART_COLOURS = {
    joint: godotColorToLinear({ r: 0.5, g: 0.8, b: 1 }),
    bodyA: godotColorToLinear({ r: 0.6, g: 0.8, b: 1 }),
    bodyB: godotColorToLinear({ r: 0.6, g: 0.9, b: 1 }),
};
export function JointGizmoLines({ part, positions }) {
    return _jsx(GizmoLine, { positions: positions, color: PART_COLOURS[part] });
}
//# sourceMappingURL=JointGizmoLines.js.map